<template>
    <span v-on:click="$emit('click', click)">
        <b-badge :variant="badge.variant" v-if="!iconOnly">
            <i class="fe" :class="badge.icon" v-if="badge.icon"></i>
            <span class="ml-1">{{ $t(badge.label) }}</span>
        </b-badge>

        <i
            class="fe"
            v-b-tooltip
            :title="$t(badge.label)"
            :class="badge.icon + ' text-' + badge.variant"
            v-if="noBadge && badge.icon"
        ></i>
        <b-badge
            :variant="badge.variant"
            v-if="iconOnly && !noBadge"
            v-b-tooltip
            :title="$t(badge.label)"
            style="font-size:16px;"
        >
            <i class="fe" :class="badge.icon" v-if="badge.icon"></i>
        </b-badge>
    </span>
</template>

<script>
import status from '@/filters/lab-status.js';
export default {
    props: ['status', 'iconOnly', 'size', 'noBadge', 'click'],
    computed: {
        badge() {
            return status(this.status)
        }
    }

}
</script>
